<template>
  <div class="social-subcomment  list-complete-item">
    <div class="sub-comment-header">
      <i class="social-comment-icon"></i>
      <img :src="$imageus + (subComment.owner.image == null ? host + '/static/500x500-user.png' : subComment.owner.image) + '?width=200&height=200&mode=cover'" alt="" />
      <div class="comment-user-title">
        {{ subComment.owner.fullName }}
      </div>
      <el-dropdown trigger="click" class="post-actions">
        <span class="el-dropdown-link">
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="deleteComment" icon="fas fa-trash">{{ $t("components.socialhub.postCard.deleteComment") }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="sub-comment-body">
      <div class="sub-comment-text" v-html="parseUrl(subComment.commentText, subComment)"></div>
      <div class="comment-buttons">
        <span class="comment-reply" :style="{ color: newComment ? '#FF6565' : '#292F3B' }" @click="replyComment">{{ $t("components.socialhub.postCard.reply") }}</span>
        <div class="like-area" @click="toggleLikeComment">
          <i class="el-icon-loading" v-if="loading == 'commentLike'"></i>
          <i class="fa fa-heart" v-else :class="{ active: this.subComment.isLiked }"></i>
          <span v-if="subComment.likeCount > 0">{{ subComment.likeCount }}</span>
        </div>
      </div>
      <transition name="el-zoom-in-top" mode="out-in">
        <div class="send-sub-comment" v-if="newComment" :key="'new-comment-area-' + subComment.id + '-key-' + newComment" @keyup.enter.exact="postComment">
          <div v-if="isCommentMentionVisible" v-swiper:mySwiper="swiperOption" class="mention-panel">
            <div class="swiper-wrapper">
              <div v-for="(user, index) in users" :key="index" @click.stop="tagUser(user, commentForm)" class="mention-item swiper-slide">
                <div :style="user.image == null ? 'background-color: f1f1f1;' : 'background-image: url(' + $imageus + user.image + '?width=200&height=200&mode=cover&background=ffffff'" class="user-image"></div>
                <p v-if="user.type == 2">{{ user.title }}</p>
                <p else>{{ user.fullName }}</p>
              </div>
            </div>
          </div>
          <el-input v-model="commentForm.commentText" resize="auto" class="comment-input" @input="commentMention(commentForm)">
            <template slot="suffix">
              <i class="el-input__icon fas " :key="loading" :class="loading == 'postCommentLoading' ? 'el-icon-loading' : 'fa-paper-plane'" @click="postComment"></i>
            </template>
          </el-input>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: ["subComment"],
  data() {
    return {
      users: [],
      isCommentMentionVisible: false,
      host: location.host == "localhost:8081" ? "https://app.holacon.com/" : "https://" + location.host,
      commentForm: {
        id: null,
        postId: this.subComment.postId,
        commentText: null,
        parentId: this.subComment.parentId,
        mentions: []
      },
      swiperOption: {
        slidesPerView: "auto",
        autoWidth: true,
        spaceBetween: 20
      },
      loading: false,
      timeout: null,
      searchTerm: null,
      newComment: false
    };
  },
  methods: {
    async deleteComment() {
      var res = await this.$store.dispatch("socialHubDeleteComment", this.subComment.id);
      if (!res.data.alert.hasError) {
        this.$emit("deleteMe", this.subComment.id);
      }
    },
    commentMention(post) {
      if (this.commentForm.commentText != "" && this.commentForm.commentText != null) {
        this.commentForm.commentText.split(" ").forEach(item => {
          if (item.startsWith("@")) {
            this.users = [];
            this.isCommentMentionVisible = true;
            this.searchTerm = item.replace("@", "");
            this.timeout = setTimeout(async () => {
              var res = await this.$store.dispatch("socialHubMentionSearch", this.searchTerm);
              this.users = res.data.data.items;
            }, 500);
          } else {
            this.isCommentMentionVisible = false;
            this.searchTerm = "";
          }
        });
      }
    },
    replyComment() {
      var fIndex = this.commentForm.mentions.findIndex(x => x.id == this.subComment.owner.id);
      if (fIndex == -1) {
        this.commentForm.mentions.push(this.subComment.owner);
      }
      this.commentForm.commentText = this.subComment.owner.fullName + " ";
      this.newComment = !this.newComment;
    },
    async toggleLikeComment() {
      this.loading = "commentLike";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          id: this.subComment.id,
          postId: this.subComment.postId,
          isLiked: !this.subComment.isLiked
        };
        var res = await this.$store.dispatch("toggleLikeComment", payload);
        if (res.status == 200) {
          if (!res.data.alert.hasError) {
            this.subComment.isLiked = !this.subComment.isLiked;
          }
        } else {
          this.loading = false;
          this.$message.error("Bir hata oluştu");
        }

        this.loading = false;
      }, 500);
    },
    postComment() {
      this.loading = "postCommentLoading";

      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var commentTitle = this.commentForm.commentText;
        if (commentTitle != null && commentTitle != "") {
          this.commentForm.mentions.forEach(user => {
            commentTitle = commentTitle.replace(user.fullName, "%" + user.id + "%");
          });
          var res = await this.$store.dispatch("socialHubAddUpdateComment", {
            id: null,
            parentId: this.subComment.parentId,
            postId: this.subComment.postId,
            commentText: commentTitle != "" ? commentTitle : this.commentForm.commentText,
            mentions: this.commentForm.mentions
          });
          if (res.data.hasError == true) {
            this.$message.error(res.data.message);
          } else {
            this.commentForm.commentText = null;
            this.users = [];
          }
          this.commentForm.mentions = [];
          this.newComment = false;
        } else {
          this.$message.error("Lütfen yorum kutucugunu doldurunuz.");
        }

        this.loading = false;
      }, 500);
    },
    parseUrl(text, post) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var usernameRegex = /\%(.*?)\%/g;
      if (text == null) return;
      text = text.replace(urlRegex, function(url) {
        return '<a href="' + url + '" target="_blank">' + url + "</a>";
      });
      post.mentions.forEach(user => {
        if (text.includes("%" + user.id + "%")) {
          text = text.replace("%" + user.id + "%", '<a href="javascript:;" user-id="' + user.id + '" class="open-user">@' + user.fullName + "</a>");
        }
      });
      return text;
    }
  }
};
</script>

<style lang="less" scoped>
.social-subcomment {
  padding: 10px 0px 10px 0;
  margin-right: 0px;
  border-top: 0.5px solid rgba(200, 205, 211, 0.4);
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  &:last-child {
    margin-bottom: 0;
  }
  gap: 10px;
  .sub-comment-header {
    display: flex;
    align-items: center;
    gap: 8px;
    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 2px solid #e8ebef;
      object-fit: cover;
    }
    .comment-user-title  {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: #000000;
    }
    .post-actions {
      color: #8c929c;
      font-size: 12px;
      text-align: end;
      justify-self: flex-end;
      cursor: pointer;
      margin-left: auto;
      margin-right: 1rem;
      span {
        i {
          font-size: 16px;
        }
      }
    }
  }
  .comment-buttons {
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: space-between;
    & > span {
      cursor: pointer;
      user-select: none;
    }
    .comment-reply {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      text-decoration-line: underline;
      color: #292f3b;
      margin-left: 4px;
      cursor: pointer;
    }
    .like-area {
      margin-left: auto;
      display: flex;
      align-items: center;
      margin-right: 8px;
      cursor: pointer;
      flex-direction: column;
      & > i {
        font-size: 14px;
        &.active {
          transition: all 0.2s;
          color: #ff6565;
        }
      }
      span {
        font-size: 12px;
      }
    }
  }
  .sub-comment-body {
    padding-left: 32px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .send-sub-comment {
    position: relative;
    .mention-panel {
      position: absolute;
      top: calc(~"-100% - 1.5rem");
      left: 0;
      display: flex;
      gap: 10px;
      background: #ffffff;
      box-shadow: 0px 2px 8px rgba(41, 47, 59, 0.24);
      border-radius: 12px;
      padding: 10px;
      height: 60px;
      width: 100%;
      overflow-y: hidden;
      overflow-x: hidden;
      .mention-item {
        flex-shrink: 0;
        cursor: pointer;
        display: flex;
        gap: 8px;
        width: max-content;
        align-items: center;
        .user-image {
          border: 2px solid #e8ebef;
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background-size: cover;
          flex-shrink: 0;
        }
        p {
          margin-bottom: 0;
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          color: #292f3b;
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/socialhub/SubComment.vue